<form *ngIf="contractInboundMailFormGroup" [formGroup]="contractInboundMailFormGroup">
    <div class="grid">
        <div class="col-12 input-field">
            <label for="mail">Correo electrónico</label>
            <input pInputText name="mail" formControlName="mail" d-form-field-error />
        </div>
    </div>

    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Eliminar" *ngIf="allowDelete && contractInboundMail.id" icon="pi pi-trash"
            styleClass="p-button-danger" (click)="delete()"></p-button>
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>

</form>